import { render, staticRenderFns } from "./ProductLight640.vue?vue&type=template&id=25b9a805&scoped=true"
import script from "./ProductLight640.vue?vue&type=script&lang=js"
export * from "./ProductLight640.vue?vue&type=script&lang=js"
import style0 from "./ProductLight640.vue?vue&type=style&index=0&id=25b9a805&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b9a805",
  null
  
)

export default component.exports